import {
  index as baseIndex,
  getFromId as baseGetFromId,
  editFromId as baseEditFromId,
  newItem as baseNewItem
 } from './Base';

/******************************************************************************
 * INDEX FUNCTION                                                             *
 ******************************************************************************/

/**
 * Get a list of appointment actions based on a pagination system
 *
 * @param page the page requested
 * @param itemPerPage the number of item in the page requested
 */
export function index(page = 1, itemPerPage = 10, search = {}, order = 'ASC', scheme = null){
  return baseIndex('appointment_actions', page, itemPerPage, search, order, scheme);
}

/******************************************************************************
 * GETTER FUNCTION                                                            *
 ******************************************************************************/

/**
 * Get a single appointment action based on his ID
 *
 * @param id the of the appointment action requested
 */
export function getFromId(id) {
  return baseGetFromId('appointment_actions', id);
}

/**
 * Get a single appointment action based on his ID
 *
 * @param id the of the appointment action requested
 */
export function getIdentificationFromId(id) {
  return baseGetFromId('appointment_actions', id, 'identification');
}

/**
 * Get a single appointment action based on his ID
 *
 * @param id the of the appointment action requested
 */
export function getPreviousPricesFromId(id) {
  return baseGetFromId('appointment_actions', id, 'previous_prices');
}

/**
 * Get a single appointment action based on his ID
 *
 * @param id the of the appointment action requested
 */
export function getFiltersFromId(id) {
  return baseGetFromId('appointment_actions', id, 'filters');
}

/******************************************************************************
 * SETTER FUNCTION                                                            *
 ******************************************************************************/

/**
 * Edit a single appointment action based on his ID
 *
 * @param id the of the appointment action requested
 * @param data the new data of the appointment action
 */
export function editFromId(id, data) {
  return baseEditFromId('appointment_actions', id, data);
}

/**
 * Edit a single appointment action based on his ID
 *
 * @param id the of the appointment action requested
 * @param data the new data of the appointment action
 */
export function editFiltersFromId(id, data) {
  return baseEditFromId('appointment_actions', id, data, 'filters');
}

/******************************************************************************
 * NEW FUNCTION                                                               *
 ******************************************************************************/

/**
 * Create a new appointment action
 *
 * @param data the new data of the appointment action
 */
export function newItem(data) {
  return baseNewItem('appointment_actions', data);
}

/******************************************************************************
 * FETCH FUNCTION                                                             *
 ******************************************************************************/

/**
 * Fetch all appointment actions to serve in a dropdown form choice
 */
export function fetchAppointmentActions(search) {
  return baseIndex('appointment_actions', 1, 0, search, 'ASC');
}

/**
 * Fetch all appointment actions to serve in a dropdown form choice
 */
export function fetchActiveAppointmentActions() {
  let search = {
    active: 1
  }
  return baseIndex('appointment_actions', 1, 0, search, 'ASC', 'main_with_filters');
}
